  <template>
  <div id="app">
    <el-card  class="login-container"
    >
      <el-row :gutter="20">
        <el-col :span="5"><div class="grid-content bg-purple">
          <el-tag>支付状态：测试测试测试</el-tag>

          <el-select v-model="TokenValue" placeholder="请选择">
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div></el-col>
        <el-col :span="4"><div class="grid-content bg-purple">
          <el-tag>广告ID：</el-tag>

          <el-input
            style="width: 200px"
            autosize
            placeholder="广告id"
            v-model="ad_id_v2">
          </el-input>
        </div></el-col>
        <el-col :span="4"><div class="grid-content bg-purple">
          <el-tag>推广ID：</el-tag>

          <el-input
            style="width: 200px"

            autosize
            placeholder="推广id"
            v-model="promotion_id">
          </el-input>

        </div></el-col>
        <el-col :span="6"><div class="grid-content bg-purple">
<!--&lt;!&ndash;666&ndash;&gt;   阿萨的a-->
          <!--  asdasd -->

<!--          测试提交最后一次-->
          <el-date-picker

            v-model="value1"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="timestamp"

            @change="chooseTimeRange">
          </el-date-picker>
          <el-button type="primary" v-on:click="downloadImages"  :disabled="isDisable" round>查询</el-button>

        </div></el-col>
      </el-row>

      <br><br><br>




      <el-table
        v-loading="loading"
        element-loading-text="拼命查询中..."
        stripe
        height="600"
        :default-sort = "{prop: 'date', order: 'descending'}"
        :data="arrData"
        id="exportTab"
        style="width: 99%">
        <el-table-column type="index" label="序号"></el-table-column>


        <el-table-column
          sortable
          prop="encrypted_device_id"
          label="用户设备id"
        >
        </el-table-column>

        <el-table-column
          sortable

          prop="promotion_id"
          label="推广ID"
>
        </el-table-column>
        <el-table-column
          sortable

          prop="promotion_name"
          label="推广链名称"
        >
        </el-table-column>
        <el-table-column
          sortable

          prop="book_name"
          label="书籍名称">
        </el-table-column>
        <el-table-column
          sortable
          prop="ad_id_v2"
          label="计划ID"
>
        </el-table-column>

        <el-table-column
          :formatter="format1"

          prop="recharge_amount"
          label="充值金额"
        >
        </el-table-column>
        <el-table-column
          prop="recharge_times"
          label="充值次数">
        </el-table-column>
        <el-table-column
          sortable
          :formatter="formatTimestamp"
          prop="timestamp"
          label="加桌时间"
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="register_time"
          label="注册时间">
        </el-table-column>
        <el-table-column
          sortable
          prop="clickid"
          label="点击ID">
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
  >
          <template slot-scope="scope">
            <el-button :disabled="scope.row.isDisabled" @click="update(scope.row)"  type="text" size="small">补充回传</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next, jumper"
        page-size="100"
        :total="total"
        @current-change="handlePageChange"
      >
      </el-pagination>
    </el-card>

  </div>

</template>

<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
import md5 from 'md5';

export default {

  name: "batchState",

  data(){
    return {

      ad_id_v2:'',
      promotion_id:'',
      loading:false,
      total:0,
      value1:'',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      options1: [

        {
          value: true,
          label: '所有用户',
        },  {
          value: false,
          label: '充值用户',
        },

      ],
      uuid:[],
      TokenValue:true,
      arrData:[],
    }},

  methods: {
    // 获取时间戳，获取时间选择器时间
    chooseTimeRange(value1){
      this.time = parseInt(new Date().getTime()) + '';
      this.value2=value1;

    },
    async handlePageChange(page){
      this.loading=true
      let ts = Math.floor(Date.now() / 1000);
      let distributor_id = "1768029056163950";
      let secret_key = "BEP3JFVzLYr7jIKHBXCQSJiGjvJjeD18";

      let sign = md5(distributor_id + secret_key + ts).toLowerCase();
      let pams={
        sign:sign,
        size:100,
        index:page-1
      }
      await this.pageInfoByLastId(pams)
      this.$nextTick(() => {
        const tableBody = document.querySelector('#exportTab .el-table__body-wrapper');
        if (tableBody) {
          tableBody.scrollTop = 0;
        }
      });

      this.loading=false
    },
    formatTimestamp(row, column) {
      const timestamp = row.timestamp;
      const date = new Date(timestamp*1000);
      return date.toLocaleString();
    },
    format1(row, column) {
      let  amount = row.recharge_amount;
      amount=amount/100
      return amount.toLocaleString();
    },
    async downloadImages() {
      this.loading=true

      let ts = Math.floor(Date.now() / 1000);
      let distributor_id = "1768029056163950";
      let secret_key = "BEP3JFVzLYr7jIKHBXCQSJiGjvJjeD18";

      let sign = md5(distributor_id + secret_key + ts).toLowerCase();
        let pams={
          sign:sign,
          size:100,
          index:0
        }

      await this.pageInfoByLastId(pams)

      this.loading=false

    },
    async update(row){

      let pamrs={
        ad_id_v2:row.ad_id_v2,
        creativetype:row.creativetype,
        clickid:row.clickid
      }
      let confirmSupplement = confirm("是否补充回传？");
      if (confirmSupplement) {
        await this.activate(pamrs);
      }
    // await this.activate(pamrs)
      row.isDisabled = false;

    },
   async activate(parms) {
      const url = encodeURIComponent('https://it.zjwec.cn/index.html?creativetype='+parms.creativetype+'&clickid='+parms.clickid);
      const finalUrl = `https://ad.oceanengine.com/track/activate/?link=${url}&event_type=2`;
      window.open(finalUrl);
    },
    async pageInfoByLastId(pams) {
      let ts = Math.floor(Date.now() / 1000);
      const params = {
        distributor_id: "1768029056163950",
        ts: ts,
        sign: pams.sign,
        page_size: pams.size,
        page_index: pams.index
      };
      if (this.value2 && this.value2.length === 2) {
        params.begin_time = this.value2[0]/1000;
        params.end_time = this.value2[1]/1000;
      }
      if (this.ad_id_v2!==''){
        params.ad_id_v2 = this.ad_id_v2
      }
      if (this.promotion_id!==''){
        params.promotion_id = this.promotion_id
      }
      if (this.TokenValue==false){
        params.show_not_recharge = this.TokenValue

      }
      const response = await this.$axios.get('/api2/user/list/v1/', {
        params: params
      });
      console.log(response.data);
      this.arrData = response.data.data;
      this.total=response.data.total
      // this.total = Math.ceil(response.data.total / pams.size);
      console.log(this.total)
    },

  }
}



</script>

<style scoped>
.login-container {
  border-radius: 15px;
  background-clip: padding-box;
  margin: 90px auto;
  width: 100%;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
</style>



// WEBPACK FOOTER //
// src/components/zuikan.vue